





























import Vue from 'vue'
import {UserViewModel} from "@/models/UserViewModel";

export default Vue.extend( {
  name: "UserList",
  data(): {
    userList: UserViewModel[];
    userHeaders: any[];
    isLoading: boolean
  }{
    return {
      userList: [],
      userHeaders: [
        { text: 'Name' , value: 'fullName' } ,
        { text: 'Email' , value: 'email' } ,
        { text: 'Title' , value: 'title' }
      ],
      isLoading: true
    }
  },
  computed: {
    loggedInUser(): UserViewModel {
      return this.$store.state.loggedInUser;
    },
  } ,
  beforeCreate() {
    setTimeout( async () => {
      if ( this.$store.state.loggedInUser == null ) {
        //make one attempt to get the current user info
        try {
          let result = await this.axios.get('Users/GetUserFromToken');
          if ( result.status === 200 ) {
            await this.$store.dispatch('updateUser', result.data);
          }
        } catch ( err ) {
          if ( err.response.status === 400  ) {
            await this.$router.push('/Login');
          }
        }
      }
    } , 250 );
  },
  mounted() {
    this.loadData();
  },
  methods: {
    async loadData() {
      let result = await this.axios.get( '/Users/GetList' );
      this.userList = result.data;
      this.isLoading = false;
    },
    async createUser() {
      await this.$router.push( { name: 'users-new' } )
    }
  },
} )

